import { render, staticRenderFns } from "./IconSelfCommonBlack.vue?vue&type=template&id=1f4d35b3"
import script from "./IconSelfCommonBlack.vue?vue&type=script&lang=js"
export * from "./IconSelfCommonBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports